import regions from "./region";
import { Notification } from "element-ui";
// 文件下载，数据转Blob二进制数据然后下载
export function downloadByContent(fileName, content, mimeType = {}) {
  const blob = new Blob([content], mimeType);
  const link = document.createElement("a");
  link.innerHTML = fileName;
  link.download = fileName;
  link.href = URL.createObjectURL(blob);
  link.click();
}
// 下载文件
export function newDownloadByUrl(url, type = "Get", params = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    if (type === "Get") {
      xhr.open("Get", url, true);
    } else {
      xhr.open(type, url, true);
      xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    }
    xhr.responseType = "blob";
    xhr.onreadystatechange = () => {
      if (xhr.status === 200 && xhr.readyState === 4) {
        resolve(xhr.response);
        const fileName = decodeURIComponent(
          xhr
            .getResponseHeader("content-disposition")
            .split(";")[1]
            .split("filename=")[1],
        );
        const link = document.createElement("a");
        link.download = fileName;
        link.href = window.URL.createObjectURL(xhr.response);
        link.click();
      }
    };
    xhr.onload = () => {
      if (xhr.response.type === "application/json") {
        const reader = new FileReader();
        reader.readAsText(xhr.response, "utf-8");
        reader.onload = () => {
          Notification({
            message: JSON.parse(reader.result).message,
            type: 'error',
          })
          reject(JSON.parse(reader.result));
        };
      }
    };
    if (type === "Get") {
      xhr.send();
    } else {
      xhr.send(JSON.stringify(params));
    }
  });
}

// 文件下载，使用a标签GET请求到后端直接下载
export function downloadByUrl(url) {
  const link = document.createElement("a");
  link.download = "download";
  link.href = url;
  document.body.appendChild(link);
  link.click();
}
// 数组去重
export function unique(array, key) {
  if (!key) {
    array = [...new Set(array)];
  } else {
    const hash = {};
    array = array.reduce((item, next) => {
      if (!hash[next[key]]) hash[next[key]] = true && item.push(next);
      return item;
    }, []);
  }
  return array;
}

// 空与空对象
export function isEmpty(data) {
  return !data || !Object.keys(data).length;
}

// 空对象
export function isEmptyObj(obj) {
  return typeof obj === "object" && obj !== null
    ? !Object.keys(obj).length
    : false;
}

// 对象深复制，简单粗暴
export function cloneObject(obj) {
  const newObj = JSON.stringify(obj);
  return JSON.parse(newObj);
}

// 对象属性提取
export function pick(obj, ...attr) {
  return attr.reduce((result, val) => {
    if (val in obj) result[val] = obj[val];
    return result;
  }, {});
}

// 获取替换key的新对象
export function replaceKey(obj, keyMap, hasAll = true) {
  return Object.keys(obj).reduce((result, key) => {
    let tempKey = keyMap[key];
    if (hasAll) tempKey = tempKey || key;
    if (tempKey) result[tempKey] = obj[key];
    return result;
  }, {});
}

// 对象value与key互换
// 数组会转换为多个key，null、undefined、其他对象不做转换，重复key后面覆盖前面
export function reverse(obj) {
  return Object.keys(obj).reduce((result, key) => {
    const value = obj[key];
    if (Array.isArray(value)) {
      value.forEach((v) => {
        result[v] = key;
      });
    } else if (value != null && typeof value !== "object") {
      result[value] = key;
    }
    return result;
  }, {});
}

// 对象属性合并，相比Object.assign，这个方法只会合并第一个对象中定义的属性
export function assignPart(obj, ...objs) {
  if (isEmpty(obj) || !objs.length) return obj;
  objs.forEach((o) => {
    Object.keys(obj).forEach((k) => {
      if (hasOwnProperty(o, k)) obj[k] = o[k];
    });
  });
  return obj;
}

// 获取一年中已度过的天数
export function getLapseDateOfYear(time) {
  const year = new Date().getFullYear().toString();
  const lapseSeconds = new Date(time) - new Date(year);
  return Math.ceil(lapseSeconds / (1000 * 60 * 60 * 24)) + 1;
}

// 日期格式化
export function formatTime(time) {
  time = new Date(time);
  const year = time.getFullYear();
  const month = time.getMonth() + 1 < 10
    ? `0${time.getMonth() + 1}`
    : `${time.getMonth() + 1}`;
  const date = time.getDate() < 10 ? `0${time.getDate() + 1}` : `${time.getDate() + 1}`;
  return `${year}-${month}-${date}`;
}
// 日期格式化 将时间戳转换成yy-mm-dd形式
export function formatTimeShow(time) {
  time = new Date(time);
  const year = time.getFullYear();
  const month = time.getMonth() + 1 < 10
    ? `0${time.getMonth() + 1}`
    : `${time.getMonth() + 1}`;
  const date = time.getDate() < 10 ? `0${time.getDate()}` : `${time.getDate()}`;
  return `${year}-${month}-${date}`;
}

// 日期格式化，年月日 => 2018-18-16
export function formatTimeYMD(time, separator = "-") {
  return formatTimeShow(time, separator);
}

// 日期格式化，时分秒 => 08:06:01
export function formatTimeHMS(time, separator = ":") {
  time = time ? new Date(time) : new Date();
  const hours = time.getHours() < 10 ? `0${time.getHours()}` : `${time.getHours()}`;
  const minutes = time.getMinutes() < 10 ? `0${time.getMinutes()}` : `${time.getMinutes()}`;
  const seconds = time.getSeconds() < 10 ? `0${time.getSeconds()}` : `${time.getSeconds()}`;

  // 分隔符
  if (Array.isArray(separator) && separator.length === 3) {
    return [hours, minutes, seconds].reduce(
      (result, v, i) => result + v + separator[i],
      "",
    );
  }
  return [hours, minutes, seconds].join(separator);
}

// 日期格式化，年月日 + 时分秒 => 2018-16-11 08:06:01
export function formatTimeFull(time, ...separator) {
  let dateSeparator = "-";
  let timeSeparator = ":";
  if (Array.isArray(separator)) {
    if (separator.length === 2) {
      dateSeparator = separator[0];
      timeSeparator = separator[1];
    } else if (separator.length === 6) {
      dateSeparator = separator.slice(0, 3);
      timeSeparator = separator.slice(3, 6);
    }
  }
  return `${formatTimeYMD(time, dateSeparator)} ${formatTimeHMS(
    time,
    timeSeparator,
  )}`;
}

/**
 * debounce
 * 简易防抖
 * @param {delay} 间隔时间
 * @param {targetFuntion} 目标函数
 */
export function debounce(delay, targetFuntion, ...args) {
  let timer;
  return function debounceFunc() {
    const ctx = this;
    // 首次立即执行
    if (timer === undefined) {
      targetFuntion.apply(ctx, args);
      timer = "isApplyed";
      return;
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      targetFuntion.apply(ctx, args);
    }, delay);
  };
}
/**
 * debounce
 * 简易节流
 * @param {delay} 延时
 * @param {targetFuntion} 目标函数
 * @param {duration} 最大执行间隔
 */
export function throttle(delay, targetFuntion, duration, ...argument) {
  let timer;
  let begin = new Date();
  return function debounceFunc() {
    const context = this;
    const args = argument;
    const current = new Date();
    if (timer === undefined) {
      targetFuntion.apply(context, args);
      timer = "isApplyed";
      return;
    }
    clearTimeout(timer);
    if (current - begin >= duration) {
      targetFuntion.apply(context, args);
      begin = current;
    } else {
      timer = setTimeout(() => {
        targetFuntion.apply(context, args);
      }, delay);
    }
  };
}
// 金额转化
const unitMagnification = {
  元: 10 ** 0,
  十: 10 ** 1,
  百: 10 ** 2,
  千: 10 ** 3,
  万: 10 ** 4,
  十万: 10 ** 5,
  百万: 10 ** 6,
  千万: 10 ** 7,
  亿: 10 ** 8,
};

// 单位换算
export function conversion(money, inputUnit = "元", outputUnit = "万") {
  money = Number.parseFloat(money)
    * (unitMagnification[inputUnit] / unitMagnification[outputUnit]);
  return Math.round(money * 100) / 100;
}

export const country = regions;

// 单位换算-换算成万
export function toTenThousand(val, isTofix) {
  if (typeof val === "string") val = Number(val.replace(/,/g, ""));
  let result = null;
  if (val <= 10000) {
    result = {
      value: isTofix ? val.toFixed(2) : val,
      isTenThousand: false,
    };
  } else if (val < 100000000) {
    result = {
      value: (val / 10000).toFixed(2),
      isTenThousand: true,
    };
  } else {
    result = {
      value: (val / 100000000).toFixed(2),
      isBillThousand: true,
    };
  }
  return result;
}

/**
 * 格式化数字
 * @param {Number|String} num - 数字或数字字符串
 * @param {Boolean} [round] - 是否清除后导0
 * @param {Number} [precision=2] - 保留小数位
 * @return {String} 格式化后的字符串
 * @example formatNumber('123456.555'); //"123,456.56"
 *          formatNumber(1.8999, true); //1.9
 *          formatNumber(1.8999, true, 2); //1.9
 *          formatNumber(1.8999, false, 3); //1.900
 */
/* eslint-disable */
export function formatMoney(num, precision = 2, thousands = ",", prefix = "") {
  if (!num || num === " ") return "0.00";
  let value = num.toString().trim();
  value = value.replace(/,/g, "");
  if (!value) return "";
  precision && (value = parseFloat(value).toFixed(precision));
  thousands && (value = value.replace(/\B(?=(\d{3})+(?!\d))/g, thousands));
  return prefix + value;
}

/**
 * 解决Vue Template模板中无法使用可选链的问题
 * @param obj
 * @param rest
 * @returns {*}
 */
/* eslint-disable */
export const optionalChaining = (obj, ...rest) => {
  let tmp = obj;
  for (const key in rest) {
    if (rest.hasOwnProperty(key)) {
      const name = rest[key];
      tmp = tmp?.[name];
    }
  }
  return tmp || "";
};

// 电话号码正则
